import { render } from "./DisableIcon.vue?vue&type=template&id=cd5e1062&scoped=true"
import script from "./DisableIcon.vue?vue&type=script&lang=js"
export * from "./DisableIcon.vue?vue&type=script&lang=js"

import "./DisableIcon.vue?vue&type=style&index=0&id=cd5e1062&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd5e1062"]])

export default __exports__